module.exports = __webpack_public_path__ + "img/ar00.45900076.jpg";